import React, { useContext, useEffect } from 'react';
import { RicosContext, RicosViewerContext } from 'ricos-context';
import { mergeStyles, containsUrl, normalizeUrl } from 'wix-rich-content-common';
import { I as INIT_WIDTH, a as INIT_HEIGHT, S as SRC_TYPE_HTML, b as SRC_TYPE_URL, H as HTML_TYPE } from './viewer-loadable2.js';
import { a as htmlComponentStyles, h as htmlFixer, I as IframeHtml, b as IframeUrl } from './htmlFixer.js';
import '@loadable/component';
import 'ricos-types';
import '@babel/runtime/helpers/assertThisInitialized';
import '@babel/runtime/helpers/inheritsLoose';
import 'prop-types';

var getPageURL = function getPageURL(siteDomain) {
  if (!siteDomain) {
    return;
  }
  var regex = /http.+com/gm;
  var res = regex.exec(siteDomain);
  if (res) {
    return res[0];
  }
};
var HtmlViewer = function HtmlViewer(_ref) {
  var settings = _ref.settings,
    componentData = _ref.componentData,
    iframeSandboxDomain = _ref.iframeSandboxDomain,
    _ref$isViewer = _ref.isViewer,
    isViewer = _ref$isViewer === void 0 ? false : _ref$isViewer;
  var _a, _b;
  var _useContext = useContext(RicosContext),
    theme = _useContext.theme,
    isMobile = _useContext.isMobile,
    experiments = _useContext.experiments;
  var _React$useState = React.useState(null),
    elementRef = _React$useState[0],
    setElementRef = _React$useState[1];
  var _React$useState2 = React.useState(),
    iframeHeight = _React$useState2[0],
    setIframeHeight = _React$useState2[1];
  useEffect(function () {
    var width = settings.width,
      height = settings.height;
    var containerData = componentData.containerData;
    if (!containerData.width) {
      if (width) {
        containerData.width = {
          custom: width
        };
      } else if (elementRef) {
        containerData.width = {
          custom: elementRef.getBoundingClientRect().width
        };
      } else {
        containerData.width = {
          custom: INIT_WIDTH
        };
      }
    }
    if (!containerData.height) {
      containerData.height = {
        custom: height || INIT_HEIGHT
      };
    }
  }, [elementRef]);
  var setHeight = function setHeight(height) {
    if (height > 0 && height !== iframeHeight) {
      setIframeHeight(height);
    }
  };
  var getIframeHeight = function getIframeHeight() {
    var _a2;
    var containerData = componentData.containerData;
    var maxDiff = iframeHeight && Math.min(50, iframeHeight * 0.1);
    var normalizedHeight = iframeHeight;
    var customHeight = (_a2 = containerData.height) == null ? void 0 : _a2.custom;
    if (customHeight) {
      if (typeof customHeight === "string" && customHeight.endsWith("%")) {
        return normalizedHeight || settings.height || INIT_HEIGHT;
      }
      if (!isNaN(parseInt(customHeight))) {
        normalizedHeight = iframeHeight && customHeight < iframeHeight && customHeight + maxDiff > iframeHeight ? iframeHeight : customHeight;
      }
    }
    return normalizedHeight || settings.height || INIT_HEIGHT;
  };
  var htmlStyles = mergeStyles({
    styles: htmlComponentStyles,
    theme: theme
  });
  var style = {
    width: isMobile ? "auto" : ((_a = componentData.containerData.width) == null ? void 0 : _a.custom) || settings.width || INIT_WIDTH + "px",
    height: getIframeHeight() + "px",
    maxHeight: iframeHeight
  };
  var html;
  if (componentData.html) {
    var pageURL = getPageURL(settings.siteDomain);
    html = htmlFixer(componentData.html, pageURL);
  }
  return /* @__PURE__ */React.createElement("div", {
    className: htmlStyles.htmlComponent,
    ref: setElementRef,
    style: style,
    "data-hook": "HtmlComponent"
  }, html && /* @__PURE__ */React.createElement(IframeHtml, {
    iframeSandboxDomain: iframeSandboxDomain || ((_b = experiments.forceIframeSandboxDomain) == null ? void 0 : _b.enabled) && "https://www.filesusr.com",
    key: SRC_TYPE_HTML,
    tabIndex: 0,
    html: html,
    onHeightChange: setHeight,
    isViewer: isViewer
  }), componentData.url && containsUrl(componentData.url) && /* @__PURE__ */React.createElement(IframeUrl, {
    key: SRC_TYPE_URL,
    tabIndex: 0,
    src: normalizeUrl(componentData.url),
    isViewer: isViewer
  }), !componentData.url || !containsUrl(componentData.url) && /* @__PURE__ */React.createElement("div", {
    className: htmlStyles.htmlComponent_placeholder
  }));
};

var Html = function Html(_ref) {
  var node = _ref.node,
    nodeIndex = _ref.nodeIndex,
    NodeViewContainer = _ref.NodeViewContainer;
  var _useContext = useContext(RicosViewerContext),
    iframeSandboxDomain = _useContext.iframeSandboxDomain,
    config = _useContext.config;
  return /* @__PURE__ */React.createElement(NodeViewContainer, {
    node: node,
    nodeIndex: nodeIndex
  }, /* @__PURE__ */React.createElement(HtmlViewer, {
    componentData: node.htmlData,
    settings: config[HTML_TYPE],
    iframeSandboxDomain: iframeSandboxDomain,
    isViewer: true
  }));
};

export { Html as default };

import 'wix-rich-content-plugin-html/dist/loadable/viewer/es/styles.viewer.min.global.css'